import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	link: {
		fontSize: 14,
		textDecoration: 'none',
	},
	saveSearchTitle: {
		fontSize: 20,
		fontWeight: 600,
		marginBottom: 16,
	},
	saveSearchDescription: {
		fontSize: 14,
		marginBottom: 16,
		color: darkGrayFontColor,
	},
	saveSearchButtonContainer: {
		display: 'flex',
		gap: 8,
		marginTop: 24,
	},
});
